import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9e533e50")

_pushScopeId("data-v-9e533e50")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_2 = { class: "label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("ul", null, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sparql.state.endpoints, (endpoint) => {
      return (_openBlock(), _createBlock("li", {
        key: endpoint.name
      }, [
        _createVNode("label", {
          title: endpoint.url
        }, [
          _createVNode("input", {
            type: "checkbox",
            checked: endpoint.enabled,
            onClick: ($event: any) => (_ctx.onEnabledEndpointsChanged(endpoint))
          }, null, 8, ["checked", "onClick"]),
          _hoisted_1,
          _createVNode("span", _hoisted_2, _toDisplayString(endpoint.name), 1)
        ], 8, ["title"]),
        _createVNode("span", {
          class: "material-icons",
          onClick: ($event: any) => (_ctx.onEdit(endpoint))
        }, "edit", 8, ["onClick"]),
        _createVNode("span", {
          class: "material-icons",
          onClick: ($event: any) => (_ctx.onRemove(endpoint))
        }, "delete_outline", 8, ["onClick"])
      ]))
    }), 128))
  ]))
})